module.exports = __webpack_public_path__ + "static/media/3950X.0859f57f.jpg";